import { IBuilderBlock } from 'components/Pages/Admin/shared/ItinerariesItemLanding/Builder/types';
import { IAccordionSpoiler, TBlock } from 'detailsv2/__blocks';
import { flatten, isNil } from 'ramda';
import generateRandomString from 'utils/generateRandomString';

type OptionBlock = Partial<TBlock> | Partial<TBlock>[] | IBuilderBlock | IBuilderBlock[];

export const hasAccordion = (newObject: OptionBlock) => {
  if (Array.isArray(newObject)) return newObject.some((block) => block.type === 'accordion');
  return newObject.type === 'accordion';
};

const handleSpoilerTitle = (title: string) => {
  return {
    type: 'text',
    data: {
      raw: {
        blocks: [
          {
            key: generateRandomString(5),
            text: title,
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [{ offset: 0, length: 24, style: 'BOLD' }],
            entityRanges: [],
            data: {},
          },
        ],
        entityMap: {},
      },
    },
  };
};

const flattenSpoilers = (spoilers?: IAccordionSpoiler[]) => {
  if (!spoilers) return [];
  return spoilers.map((spoiler) => {
    return [
      handleSpoilerTitle(spoiler.title),
      ...(spoiler?.body && isNil(spoiler?.children) ? [{ type: 'text', data: spoiler.body }] : []),
      ...(spoiler?.children ?? []),
    ];
  });
};

const flattenAccordions = (newObject: OptionBlock) => {
  if (Array.isArray(newObject)) {
    const handledBlocks = newObject.map((block) => {
      if (block.type === 'accordion' && block?.data && 'spoilers' in block.data)
        return flattenSpoilers(block.data.spoilers);

      return block;
    });

    return flatten(handledBlocks);
  }

  return newObject.type === 'accordion' && newObject?.data && 'spoilers' in newObject.data
    ? flattenSpoilers(newObject.data.spoilers)
    : newObject;
};

export const handleNestedAccordion = (newObject: OptionBlock) => {
  if (hasAccordion(newObject)) return flattenAccordions(newObject);

  return newObject;
};
